const generateImportColumnSelectDataProps = (fileDatas, isFirstRowContainingHeadings) => ({
    formatItem: (item) =>
        // `Spalte ${item + 1}:${!isFirstRowContainingHeadings ? "" : ` ${fileDatas[0][item]}`}`,
        `Spalte ${item + 1}`,
    items: Array.from(Array(fileDatas[0].length).keys()),
});

export { generateImportColumnSelectDataProps };
